import { createSlice, isAnyOf, PayloadAction } from "@reduxjs/toolkit";
import {
  getFiltersData,
  getProductCategoryData,
  getRiskImpactScatterPlotData,
  getRiskMapChartData,
  getRiskMapChartSalesData,
  getRiskMitigationTrackerData,
  getRiskSupplyChainTreeData,
} from "./risk-management.async";

const initialState = {
  riskMitigationTrackerLoader: false,
  riskMitigationTableData: {},
  riskImpactScatterPlotLoader: false,
  riskImpactScatterPlotData: [],
  riskSupplyChainTreeLoader: false,
  riskSupplyChainTreeData: [],
  riskMapChartLoader: false,
  riskMapChartSalesLoader: false,
  riskMapChartData: [],
  riskMapChartSalesData: [],
  riskFiltersLoader: false,
  riskFiltersData: {},
  productCategoryLoader: false,
  productCategoryData: [],
};

const RiskManagementReducer = createSlice({
  name: "RiskManagementReducer",
  initialState,
  reducers: {
    emptyRiskManagementReducer: (state) => {
      state.productCategoryData = [];
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      isAnyOf(getRiskMitigationTrackerData.pending),
      (state) => {
        state.riskMitigationTrackerLoader = true;
      }
    );
    builder.addMatcher(
      isAnyOf(getRiskMitigationTrackerData.fulfilled),
      (state, action) => {
        state.riskMitigationTrackerLoader = false;
        state.riskMitigationTableData = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(getRiskMitigationTrackerData.rejected),
      (state) => {
        state.riskMitigationTrackerLoader = false;
      }
    );
    builder.addMatcher(
      isAnyOf(getRiskImpactScatterPlotData.pending),
      (state) => {
        state.riskImpactScatterPlotLoader = true;
      }
    );
    builder.addMatcher(
      isAnyOf(getRiskImpactScatterPlotData.fulfilled),
      (state, action) => {
        state.riskImpactScatterPlotLoader = false;
        state.riskImpactScatterPlotData = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(getRiskImpactScatterPlotData.rejected),
      (state) => {
        state.riskImpactScatterPlotLoader = false;
      }
    );
    builder.addMatcher(isAnyOf(getRiskSupplyChainTreeData.pending), (state) => {
      state.riskSupplyChainTreeLoader = true;
    });
    builder.addMatcher(
      isAnyOf(getRiskSupplyChainTreeData.fulfilled),
      (state, action) => {
        state.riskSupplyChainTreeLoader = false;
        state.riskSupplyChainTreeData = action.payload.data;
      }
    );
    builder.addMatcher(
      isAnyOf(getRiskSupplyChainTreeData.rejected),
      (state) => {
        state.riskSupplyChainTreeLoader = false;
      }
    );
    builder.addMatcher(isAnyOf(getRiskMapChartData.pending), (state) => {
      state.riskMapChartLoader = true;
    });
    builder.addMatcher(
      isAnyOf(getRiskMapChartData.fulfilled),
      (state, action) => {
        state.riskMapChartLoader = false;
        state.riskMapChartData = action.payload.data;
      }
    );
    builder.addMatcher(isAnyOf(getRiskMapChartData.rejected), (state) => {
      state.riskMapChartLoader = false;
    });
    builder.addMatcher(isAnyOf(getFiltersData.pending), (state) => {
      state.riskFiltersLoader = true;
    });
    builder.addMatcher(
      isAnyOf(getFiltersData.fulfilled),
      (state, action) => {
        state.riskFiltersLoader = false;
        state.riskFiltersData = action.payload.data;
      }
    );
    builder.addMatcher(isAnyOf(getFiltersData.rejected), (state) => {
      state.riskFiltersLoader = false;
    });
    builder.addMatcher(isAnyOf(getProductCategoryData.pending), (state) => {
      state.productCategoryLoader = true;
    });
    builder.addMatcher(
      isAnyOf(getProductCategoryData.fulfilled),
      (state, action) => {
        state.productCategoryLoader = false;
        state.productCategoryData = action.payload.data;
      }
    );
    builder.addMatcher(isAnyOf(getProductCategoryData.rejected), (state) => {
      state.productCategoryLoader = false;
    });
    builder.addMatcher(isAnyOf(getRiskMapChartSalesData.pending), (state) => {
      state.riskMapChartSalesLoader = true;
    });
    builder.addMatcher(
      isAnyOf(getRiskMapChartSalesData.fulfilled),
      (state, action) => {
        state.riskMapChartSalesLoader = false;
        state.riskMapChartSalesData = action.payload.data;
      }
    );
    builder.addMatcher(isAnyOf(getRiskMapChartSalesData.rejected), (state) => {
      state.riskMapChartSalesLoader = false;
    });
  },
});

export const { emptyRiskManagementReducer } = RiskManagementReducer.actions;
export default RiskManagementReducer.reducer;
